import { userColours } from "../assets/general";
import { EventLog } from "../types/SharedTypes";

const formatEventLog = ({relevantUsers, message, relevantCard}: EventLog, outline?: boolean) => {
  const parts: React.ReactNode[] = [];
  const regex = /\[(.*?)\]/g;

  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = regex.exec(message)) !== null) {
    const [placeholder, key] = match;
    const before = message.slice(lastIndex, match.index);
    if (before) parts.push(before);

    if (key.startsWith("name")) {
      const index = parseInt(key.replace("name", ""), 10);
      const user = relevantUsers[index];
      if (user) {
        parts.push(
          <span className={`weight-bold ${outline ? "outline" : ""}`} key={parts.length} style={{color: userColours[user.colour]}}>
            {user.name}
          </span>
        );
      } else {
        parts.push(placeholder); // fallback if index is out of range
      }
    } else if (key === "all-names") {
      const allNames = relevantUsers.map((user, i) => (
        <span className={`weight-bold ${outline ? "outline" : ""}`} key={i} style={{color: userColours[user.colour]}}>
          {user.name}
          {i < relevantUsers.length - 1 ? ", " : ""}
        </span>
      ));
      parts.push(...allNames);
    } else if (key === 'card') {
      //handle card
    } else {
      // unknown placeholder, just render as-is
      parts.push(placeholder);
    }

    lastIndex = regex.lastIndex;
  }

  // Add remaining text after the last placeholder
  if (lastIndex < message.length) {
    parts.push(message.slice(lastIndex));
  }

  return <>{parts}</>;
}
export default formatEventLog;